import { defineStore } from 'pinia'

/** @useRootStore is utilized for properties that are shared globally. */
export const useRootStore = defineStore('root', {
  getters: {
    currentPath(): string | undefined {
      return this.$router?.currentRoute?.value?.path
    },
  },
})
